import {AuthService} from './../services/auth.service';
import {AfterViewInit, Component, OnInit} from '@angular/core';
// import * as $ from 'jquery';
// import { CurrentUser } from '../shared/user.model';

@Component({
  selector: 'pm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  currentUser: any = {};
  actualDate = new Date();

  constructor(public auth: AuthService) {
  }

  ngOnInit() {
    if (this.currentUser) {
      const sessionUser = localStorage.getItem('currentUser');
      console.log('HeaderComponent: constructor: sessionUser: ', sessionUser);
      this.currentUser = sessionUser ? JSON.parse(sessionUser) : null;
      console.log('HeaderComponent: constructor: currentUser: ', this.currentUser);
    }
  }

  ngAfterViewInit() {
  }
}
